<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            placeholder="Referência..."
                            optionsData="id"
                            :optionsList="[
                                { id: 'E', search: 'Emissão' }, 
                                { id: 'V', search: 'Vencimento' }, 
                                { id: 'P', search: 'Pagamento' }, 
                                { id: 'I', search: 'Imposto' }
                            ]"
                            v-model="referencia">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="load()">
                                        <i class="fas fa-sync-alt"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" />
                    </div>
                    <!--
                        <az-input 
                            icon="far fa-calendar-alt"
                            type="select"
                            placeholder="Livre"
                            :optionsList="[
                                { id: 'm', search: 'Mês Atual' },
                                { id: 'ma', search: 'Mês Anterior' },
                                { id: 'h', search: 'Hoje' },
                                { id: 'o', search: 'Ontem' },
                                { id: 'do', search: 'Desde Ontem' },
                                { id: 's', search: 'Semana' },
                                { id: 'a', search: 'Ano Atual' },
                                { id: 'aa', search: 'Ano Anterior' },
                            ]"
                            optionsDisplay="search"
                            optionsData="id"
                            v-model="periodo" 
                            @input="load()" >
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fas fa-greater-than-equal fa-fw" 
                            type="date" 
                            :edicao="!periodo"
                            v-model="from" 
                            @input="load()" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input 
                            icon="fas fa-less-than-equal fa-fw"
                            type="date" 
                            :edicao="!periodo"
                            v-model="to" 
                            @input="load()" />
                    </div>
                    -->
                    <div class="col col-12 col-md-4">
                        <az-input
                            icon="fa fa-building fa-fw"
                            type="select"
                            mode="json"
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            v-model="unidade_operacao" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12">
                        <az-input
                            icon="fa fa-search fa-fw" 
                            v-model="search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="lista.length">
                                    <button class="btn btn-outline-primary" type="button" @click="incluir_lancamento()"
                                        :disabled="unidade_operacao ? false : true">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                                <print-export printid="impostos-retidos" :dados="dadosFormatados" />
                            </template>
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2" v-if="impostos">
                    <div class="col col-12">
                        <az-input
                            sizing="sm"
                            type="button-group"
                            :optionsList="lista_impostos"
                            v-model="imposto" 
                            @input="load()" />
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state v-if="!lista.length" />

        <div v-else id="impostos-retidos">

            <cabecalho-generico titulo="Impostos Retidos">
                <div v-if="unidade_operacao">{{ valor_display($store.state.unidade.unidade_operacaos, unidade_operacao, 'id_unidade_operacao', 'st_nome') }}</div>
                <div v-if="imposto">Imposto: {{ valor_display(lista_impostos, imposto, 'id_imposto', 'search') }}</div>
            </cabecalho-generico>
            
            <table class="table bg-white cabecalho-fixo">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Data</th>
                        <th>Und</th>
                        <th>Fornecedor</th>
                        <th>Doc</th>
                        <th>Descrição</th>
                        <th>Vencimento</th>
                        <th class="text-right">Valor</th>
                        <th class="text-right">Retenção</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-info">
                        <th colspan="7">Total</th>
                        <th class="text-right">{{ $util.formatMoeda(total_lancamentos) }}</th>
                        <th class="text-right">{{ $util.formatMoeda(total_retidos) }}</th>
                    </tr>
                    <tr v-for="(item, iix) in lista" :key="iix" class="small">
                        <td>
                            <a href="#" @click.prevent="editar(item)" class="card-link">
                                #{{ item.id_lancamento }}
                            </a>
                        </td>
                        <td>{{ $util.getFormatDate(item[campo_data]) }}</td>
                        <td>
                            <span class="badge badge-light" v-if="item.unidade_operacao">
                                {{ item.unidade_operacao.st_sigla }}
                            </span>
                        </td>
                        <td>{{ item.fornecedor ? item.fornecedor.search : '' }}</td>
                        <td>{{ item.st_doc }}</td>
                        <td>{{ item.st_descricao }}</td>
                        <td><span v-if="item.retencao && item.retencao.dt_vencimento">{{ $util.getFormatDate(item.retencao.dt_vencimento) }}</span></td>
                        <td class="text-right">{{ $util.formatMoeda(item.dc_valor) }}</td>
                        <td class="text-right">
                            <span v-if="item.retencao">{{ $util.formatMoeda(item.retencao.dc_valor) }}</span>
                            <span v-else>{{ $util.formatMoeda(valor_retencoes(item)) }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>

        <template v-if="dados && dados.apurado && dados.apurado.length">

            <p>Apurado</p>
            <table class="table bg-white cabecalho-fixo">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Vencimento</th>
                        <th>Descrição</th>
                        <th class="text-right">Valor</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, iix) in dados.apurado" :key="iix" class="small">
                        <td>
                            <a href="#" @click.prevent="editar(item)" class="card-link">
                                #{{ item.id_lancamento }}
                            </a>
                        </td>
                        <td>{{ $util.getFormatDate(item.dt_vencimento) }}</td>
                        <td>{{ item.st_descricao }}</td>
                        <td class="text-right">{{ $util.formatMoeda(item.dc_valor) }}</td>
                    </tr>
                </tbody>
            </table>

        </template>

        <pre v-if="false" class="alert alert-info">{{ dados }}</pre>

        <edicao-lancamento :unidade="unidade_operacao" ref="lancamento" @refresh="load()" />
    </div>
</template>

<script>
import _ from 'lodash';
import * as moment from 'moment';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import EdicaoLancamento from './EdicaoLancamento.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import PrintExport from "../../shared/PrintExport.vue";
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';

export default {
    data() { 
        return {
            referencia: "I", 
            from: this.$util.hoje(),
            to: this.$util.hoje(),
            unidade_operacao: "",
            impostos: null, 
            imposto: "", 
            dados: null, 
            search: "", 
            periodo: "ma", 
            filtros: { 
                periodo: "m", 
                inicio: "",
                fim: "",
            }
        };
    },

    components: { 
        AzInput, 
        AzEmptyState, 
        EdicaoLancamento, 
        AzPeriodo, 
        PrintExport, 
        CabecalhoGenerico, 
    },

    props: ['parms'],

    computed: { 
        dadosFormatados: function () { 

            return this.lista.map(lanc => { 
                return { 
                    id: lanc.id_lancamento, 
                    data: this.$util.getFormatDate(lanc[this.campo_data]),
                    fornecedor: lanc.fornecedor ? lanc.fornecedor.search : '', 
                    doc: lanc.st_doc,
                    descricao: lanc.st_descricao,
                    vencimento: ( lanc.retencao && lanc.retencao.dt_vencimento ) ? this.$util.getFormatDate(lanc.retencao.dt_vencimento) : '',
                    valor: this.$util.formatMoeda(lanc.dc_valor),
                    retencao: lanc.retencao ? this.$util.formatMoeda(lanc.retencao.dc_valor) : this.$util.formatMoeda(this.valor_retencoes(lanc)),  
                }
            });

        },

        lista_impostos: function () { 
            if ( !this.impostos )
                return [];

            let base = [
                {id_imposto: null, search: 'Todos'},
            ]; 

            if ( !this.impostos.find(imposto => imposto.search == 'PCC') ) { 
                base.push({id_imposto: 'PCC', search: 'PCC', id: -9});
            }

            return base.concat(
                    this.impostos.map(item => { 
                    item.id = item.id_imposto;
                    return item;
                })
            );
        },

        lista: function () { 
            if ( !this.dados || !this.dados.retencoes )
                return [];

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados.retencoes.filter (item => { 
                    return ( !this.search || reg.test(JSON.stringify(item)) );
                });
        },

        total_lancamentos: function() { 
            return this.lista.reduce((total, carry) => total + carry.dc_valor, 0);
        },

        total_retidos: function() { 
            return this.lista.reduce((total, carry) => total + ( carry.retencao ? carry.retencao.dc_valor : this.valor_retencoes(carry) ), 0);
        },

        campo_data: function() { 
            switch (this.referencia) {
                case 'E': return 'dt_emissao';
                case 'V': return 'dt_vencimento';
                case 'P': return 'dt_baixa';
            }

            return 'dt_emissao';
        }

    },

    methods: { 
        valor_display(lista, valor, campoData, campoDisplay) { 
            if ( !lista )
                return;

            const item = lista.find(item => _.get(item, campoData) == valor);

            return _.get(item, campoDisplay);
        },

        valor_retencoes(item) { 
            return item.retencoes ? item.retencoes.reduce((total, carry) => { 
                return total + carry.dc_valor;
            }, 0) : 0;
        },

        editar (item) { 
            this.$refs.lancamento.editar(item);
        },

        incluir_lancamento() { 
            let descricao = this.impostos.find(item => item.id_imposto == this.imposto);

            this.$refs.lancamento.incluir(
                false, 
                null, 
                { 
                    st_descricao: descricao ? descricao.search + ' Retido' : 'Imposto',
                    dc_valor: this.total_retidos,
                    gerar_imposto: true,
                });
        },

        load() { 
            /*
            if ( !this.referencia || !this.from || !this.to || !this.imposto ) { 
                this.dados = [];
                return;
            }
            */

           this.$util.load(this, { 
                service: 'financeiro',
                func: 'apuracao_impostos',
                parms: { 
                    referencia: this.referencia, 
                    id_unidade_operacao: this.unidade_operacao,
                    id_imposto: this.imposto, 
                    unidades: this.$store.state.unidade.unidade_operacaos.length, 
                    ...this.filtros, 
                },
            })
        },
    },

    created () { 
    
        if ( this.parms ) { 

            if ( this.parms.mes != 'T' && this.parms.mes ) {

                /*
                { id: 'diario', search: 'Diário' }, 
                { id: '3D', search: 'Diário (cada 3 dias)' }, 
                { id: 'semana', search: 'Semana' }, 
                { id: 'mensal', search: 'Mensal' }
                */

                if ( this.parms.tempo == 'diario' ) { 
                    this.filtros.periodo = "ld";
                    this.filtros.inicio = this.parms.mes;
                    this.referencia = 'I';    
                } else if ( this.parms.tempo == '3D' ) { 
                    this.filtros.periodo = "";
                    this.filtros.inicio = moment(this.parms.mes).subtract(2, "days").format('YYYY-MM-DD');
                    this.filtros.fim = this.parms.mes;
                    this.referencia = 'I';    
                } else if ( this.parms.tempo == 'semana' ) { 
                    this.filtros.periodo = "";
                    this.filtros.inicio = moment(this.parms.mes).subtract(6, "days").format('YYYY-MM-DD');
                    this.filtros.fim = this.parms.mes;
                    this.referencia = 'I';    
                } else { 
                    this.filtros.periodo = "lm";
                    this.filtros.mes = this.parms.mes;
                    this.referencia = 'I';
                }
                //this.imposto = {id_imposto: null, search: 'Todos'};
            }

        }

    },

    mounted() { 

        this.$store.commit("setBreadcrumb", [
            { name: "Financeiro", path: "/financeiro" },
            { name: "Imposto Retidos", path: "/financeiro/impostos-retidos" }
        ]);

        if ( this.$route.path != '/financeiro/impostos-retidos' ) { 
            this.$router.push({ path: '/financeiro/impostos-retidos' });
        }

        if ( this.$store.state.unidade.unidade_operacaos.length == 1 ) { 
            this.unidade_operacao = this.$store.state.unidade.unidade_operacaos[0].id_unidade_operacao;
        }

        this.$util.loadItem(this, { 
            service: 'impostos',
            func: 'index',
            parms: { 
                where: { 
                    fl_ativo: true,
                    fl_a_receber: 0, 
                }
            }
        })
        .then(res => { 
            this.impostos = res;
        });

        if ( this.parms ) 
            this.load();
    }
}
</script>